import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { SearchBy } from '../../../enums/enums'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { AppType } from '../../../types/app.type'

type SearchCategoryType = 'tracks' | 'producers' | 'genres'

@Component({
  selector: 'bmcore-catalog-page',
  templateUrl: './bmcore-catalog-page.component.html',
  styleUrls: ['./bmcore-catalog-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreCatalogPageComponent implements OnInit {
  @Input() appType: AppType

  @Input() showVerificationIcon = false

  lg: LgType
  searchCategory = SearchBy.Beats
  SearchBy = SearchBy

  constructor(
    private titleService: Title,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.titleService.setTitle(`${this.lg.documentTitles.allBeatmakersCatalog}`)
  }

  changeSearchCategory(searchCategory: SearchCategoryType) {
    switch (searchCategory) {
      case 'tracks':
        this.searchCategory = SearchBy.Beats
        break
      case 'producers':
        this.searchCategory = SearchBy.Beatmakers
        break
    }
  }
}
